import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

interface SettingsPageHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  actions?: React.ReactNode;
}

export const SettingsPageHeader: React.FC<SettingsPageHeaderProps> = ({
  icon,
  title,
  subtitle,
  actions,
}) => (
  <Paper
    sx={{
      mb: 3,
      p: { xs: 3, md: 4 },
      borderRadius: 3,
      border: '1px solid',
      borderColor: 'divider',
      boxShadow: 'none',
      background: 'linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%)',
    }}
  >
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={2}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', lg: 'center' }}
    >
      <Box>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
          {icon}
          <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
        </Stack>
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>

      {actions ? actions : null}
    </Stack>
  </Paper>
);
